import { Stack, StackProps } from './Stack'

// Atom for creating a horizontal stack of elements

type HStackProps = Omit<StackProps, 'direction'>

export function HStack({ align = 'center', ...props }: HStackProps) {
  return <Stack align={align} {...props} direction="row" />
}
